import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  TPersonalDataApplicationRequest,
  TPersonalDataGetApplicationsRevokeFormResponse,
  TPersonalDataGetApplicationsSubmitFormResponse,
} from '~/store/processing-personal/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const getApplicationForm = createAsyncThunk<
  TPersonalDataGetApplicationsSubmitFormResponse,
  TPersonalDataApplicationRequest
>('processingPersonal/getApplicationFormSubmit', async ({ applicationId }, { rejectWithValue }) => {
  try {
    const response = await api.get(
      `/personal-data/public/personal-data/applications/${applicationId}`
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const revokeGetApplicationForm = createAsyncThunk<
  TPersonalDataGetApplicationsRevokeFormResponse,
  TPersonalDataApplicationRequest
>('processingPersonal/getApplicationFormRevoke', async ({ applicationId }, { rejectWithValue }) => {
  try {
    const response = await api.get(
      `/personal-data/public/personal-data/revoke/applications/${applicationId}`
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
